// https://www.iso.org
export var Country;

(function (Country) {
  Country["Afghanistan"] = "AFG";
  Country["AlandIslands"] = "ALA";
  Country["Albania"] = "ALB";
  Country["Algeria"] = "DZA";
  Country["AmericanSamoa"] = "ASM";
  Country["Andorra"] = "AND";
  Country["Angola"] = "AGO";
  Country["Anguilla"] = "AIA";
  Country["Antarctica"] = "ATA";
  Country["AntiguaAndBarbuda"] = "ATG";
  Country["Argentina"] = "ARG";
  Country["Armenia"] = "ARM";
  Country["Aruba"] = "ABW";
  Country["Australia"] = "AUS";
  Country["Austria"] = "AUT";
  Country["Azerbaijan"] = "AZE";
  Country["Bahamas"] = "BHS";
  Country["Bahrain"] = "BHR";
  Country["Bangladesh"] = "BGD";
  Country["Barbados"] = "BRB";
  Country["Belarus"] = "BLR";
  Country["Belgium"] = "BEL";
  Country["Belize"] = "BLZ";
  Country["Benin"] = "BEN";
  Country["Bermuda"] = "BMU";
  Country["Bhutan"] = "BTN";
  Country["BoliviaPlurinationalStateOf"] = "BOL";
  Country["BonaireSintEustatiusAndSaba"] = "BES";
  Country["BosniaAndHerzegovina"] = "BIH";
  Country["Botswana"] = "BWA";
  Country["BouvetIsland"] = "BVT";
  Country["Brazil"] = "BRA";
  Country["BritishIndianOceanTerritory"] = "IOT";
  Country["BruneiDarussalam"] = "BRN";
  Country["Bulgaria"] = "BGR";
  Country["BurkinaFaso"] = "BFA";
  Country["Burundi"] = "BDI";
  Country["CaboVerde"] = "CPV";
  Country["Cambodia"] = "KHM";
  Country["Cameroon"] = "CMR";
  Country["Canada"] = "CAN";
  Country["CaymanIslands"] = "CYM";
  Country["CentralAfricanRepublic"] = "CAF";
  Country["Chad"] = "TCD";
  Country["Chile"] = "CHL";
  Country["China"] = "CHN";
  Country["ChristmasIsland"] = "CXR";
  Country["CocosKeelingIslands"] = "CCK";
  Country["Colombia"] = "COL";
  Country["Comoros"] = "COM";
  Country["CongoDemocraticRepublicOf"] = "COD";
  Country["Congo"] = "COG";
  Country["CookIslands"] = "COK";
  Country["CostaRica"] = "CRI";
  Country["Croatia"] = "HRV";
  Country["Cuba"] = "CUB";
  Country["Curacao"] = "CUW";
  Country["Cyprus"] = "CYP";
  Country["Czechia"] = "CZE";
  Country["CoteDIvoire"] = "CIV";
  Country["Denmark"] = "DNK";
  Country["Djibouti"] = "DJI";
  Country["Dominica"] = "DMA";
  Country["DominicanRepublic"] = "DOM";
  Country["Ecuador"] = "ECU";
  Country["Egypt"] = "EGY";
  Country["ElSalvador"] = "SLV";
  Country["EquatorialGuinea"] = "GNQ";
  Country["Eritrea"] = "ERI";
  Country["Estonia"] = "EST";
  Country["Eswatini"] = "SWZ";
  Country["Ethiopia"] = "ETH";
  Country["FalklandIslandsMalvinas"] = "FLK";
  Country["FaroeIslands"] = "FRO";
  Country["Fiji"] = "FJI";
  Country["Finland"] = "FIN";
  Country["France"] = "FRA";
  Country["FrenchGuiana"] = "GUF";
  Country["FrenchPolynesia"] = "PYF";
  Country["FrenchSouthernTerritories"] = "ATF";
  Country["Gabon"] = "GAB";
  Country["Gambia"] = "GMB";
  Country["Georgia"] = "GEO";
  Country["Germany"] = "DEU";
  Country["Ghana"] = "GHA";
  Country["Gibraltar"] = "GIB";
  Country["Greece"] = "GRC";
  Country["Greenland"] = "GRL";
  Country["Grenada"] = "GRD";
  Country["Guadeloupe"] = "GLP";
  Country["Guam"] = "GUM";
  Country["Guatemala"] = "GTM";
  Country["Guernsey"] = "GGY";
  Country["Guinea"] = "GIN";
  Country["GuineaBissau"] = "GNB";
  Country["Guyana"] = "GUY";
  Country["Haiti"] = "HTI";
  Country["HeardIslandAndMcDonaldIslands"] = "HMD";
  Country["HolySee"] = "VAT";
  Country["Honduras"] = "HND";
  Country["HongKong"] = "HKG";
  Country["Hungary"] = "HUN";
  Country["Iceland"] = "ISL";
  Country["India"] = "IND";
  Country["Indonesia"] = "IDN";
  Country["IranIslamicRepublicOf"] = "IRN";
  Country["Iraq"] = "IRQ";
  Country["Ireland"] = "IRL";
  Country["IsleOfMan"] = "IMN";
  Country["Israel"] = "ISR";
  Country["Italy"] = "ITA";
  Country["Jamaica"] = "JAM";
  Country["Japan"] = "JPN";
  Country["Jersey"] = "JEY";
  Country["Jordan"] = "JOR";
  Country["Kazakhstan"] = "KAZ";
  Country["Kenya"] = "KEN";
  Country["Kiribati"] = "KIR";
  Country["KoreaDemocraticPeoplesRepublicOf"] = "PRK";
  Country["KoreaRepublicOf"] = "KOR";
  Country["Kuwait"] = "KWT";
  Country["Kyrgyzstan"] = "KGZ";
  Country["LaoPeoplesDemocraticRepublic"] = "LAO";
  Country["Latvia"] = "LVA";
  Country["Lebanon"] = "LBN";
  Country["Lesotho"] = "LSO";
  Country["Liberia"] = "LBR";
  Country["Libya"] = "LBY";
  Country["Liechtenstein"] = "LIE";
  Country["Lithuania"] = "LTU";
  Country["Luxembourg"] = "LUX";
  Country["Macao"] = "MAC";
  Country["Madagascar"] = "MDG";
  Country["Malawi"] = "MWI";
  Country["Malaysia"] = "MYS";
  Country["Maldives"] = "MDV";
  Country["Mali"] = "MLI";
  Country["Malta"] = "MLT";
  Country["MarshallIslands"] = "MHL";
  Country["Martinique"] = "MTQ";
  Country["Mauritania"] = "MRT";
  Country["Mauritius"] = "MUS";
  Country["Mayotte"] = "MYT";
  Country["Mexico"] = "MEX";
  Country["MicronesiaFederatedStatesOf"] = "FSM";
  Country["MoldovaRepublicOf"] = "MDA";
  Country["Monaco"] = "MCO";
  Country["Mongolia"] = "MNG";
  Country["Montenegro"] = "MNE";
  Country["Montserrat"] = "MSR";
  Country["Morocco"] = "MAR";
  Country["Mozambique"] = "MOZ";
  Country["Myanmar"] = "MMR";
  Country["Namibia"] = "NAM";
  Country["Nauru"] = "NRU";
  Country["Nepal"] = "NPL";
  Country["Netherlands"] = "NLD";
  Country["NewCaledonia"] = "NCL";
  Country["NewZealand"] = "NZL";
  Country["Nicaragua"] = "NIC";
  Country["Niger"] = "NER";
  Country["Nigeria"] = "NGA";
  Country["Niue"] = "NIU";
  Country["NorfolkIsland"] = "NFK";
  Country["NorthMacedonia"] = "MKD";
  Country["NorthernMarianaIslands"] = "MNP";
  Country["Norway"] = "NOR";
  Country["Oman"] = "OMN";
  Country["Pakistan"] = "PAK";
  Country["Palau"] = "PLW";
  Country["PalestineStateOf"] = "PSE";
  Country["Panama"] = "PAN";
  Country["PapuaNewGuinea"] = "PNG";
  Country["Paraguay"] = "PRY";
  Country["Peru"] = "PER";
  Country["Philippines"] = "PHL";
  Country["Pitcairn"] = "PCN";
  Country["Poland"] = "POL";
  Country["Portugal"] = "PRT";
  Country["Qatar"] = "QAT";
  Country["Romania"] = "ROU";
  Country["RussianFederation"] = "RUS";
  Country["Rwanda"] = "RWA";
  Country["Reunion"] = "REU";
  Country["SaintBarthelemy"] = "BLM";
  Country["SaintHelenaAscensionAndTristandaCunha"] = "SHN";
  Country["SaintKittsAndNevis"] = "KNA";
  Country["SaintLucia"] = "LCA";
  Country["SaintMartin"] = "MAF";
  Country["SaintPierreAndMiquelon"] = "SPM";
  Country["SaintVincentAndGrenadines"] = "VCT";
  Country["Samoa"] = "WSM";
  Country["SanMarino"] = "SMR";
  Country["SaoTomeAndPrincipe"] = "STP";
  Country["SaudiArabia"] = "SAU";
  Country["Senegal"] = "SEN";
  Country["Serbia"] = "SRB";
  Country["Seychelles"] = "SYC";
  Country["SierraLeone"] = "SLE";
  Country["Singapore"] = "SGP";
  Country["SintMaarten"] = "SXM";
  Country["Slovakia"] = "SVK";
  Country["Slovenia"] = "SVN";
  Country["SolomonIslands"] = "SLB";
  Country["Somalia"] = "SOM";
  Country["SouthAfrica"] = "ZAF";
  Country["SouthGeorgiaAndSouthSandwichIslands"] = "SGS";
  Country["SouthSudan"] = "SSD";
  Country["Spain"] = "ESP";
  Country["SriLanka"] = "LKA";
  Country["Sudan"] = "SDN";
  Country["Suriname"] = "SUR";
  Country["SvalbardAndJanMayen"] = "SJM";
  Country["Sweden"] = "SWE";
  Country["Switzerland"] = "CHE";
  Country["SyrianArabRepublic"] = "SYR";
  Country["TaiwanProvinceOfChina"] = "TWN";
  Country["Tajikistan"] = "TJK";
  Country["TanzaniaUnitedRepublicOf"] = "TZA";
  Country["Thailand"] = "THA";
  Country["TimorLeste"] = "TLS";
  Country["Togo"] = "TGO";
  Country["Tokelau"] = "TKL";
  Country["Tonga"] = "TON";
  Country["TrinidadAndTobago"] = "TTO";
  Country["Tunisia"] = "TUN";
  Country["Turkey"] = "TUR";
  Country["Turkmenistan"] = "TKM";
  Country["TurksAndCaicosIslands"] = "TCA";
  Country["Tuvalu"] = "TUV";
  Country["Uganda"] = "UGA";
  Country["Ukraine"] = "UKR";
  Country["UnitedArabEmirates"] = "ARE";
  Country["UnitedKingdomOfGreatBritainAndNorthernIreland"] = "GBR";
  Country["UnitedStatesMinorOutlyingIslands"] = "UMI";
  Country["UnitedStatesOfAmerica"] = "USA";
  Country["Uruguay"] = "URY";
  Country["Uzbekistan"] = "UZB";
  Country["Vanuatu"] = "VUT";
  Country["VenezuelaBolivarianRepublicOf"] = "VEN";
  Country["VietNam"] = "VNM";
  Country["VirginIslandsBritish"] = "VGB";
  Country["VirginIslandsUS"] = "VIR";
  Country["WallisAndFutuna"] = "WLF";
  Country["WesternSahara"] = "ESH";
  Country["Yemen"] = "YEM";
  Country["Zambia"] = "ZMB";
  Country["Zimbabwe"] = "ZWE";
})(Country || (Country = {}));

export var AllCountries = [Country.Afghanistan, Country.AlandIslands, Country.Albania, Country.Algeria, Country.AmericanSamoa, Country.Andorra, Country.Angola, Country.Anguilla, Country.Antarctica, Country.AntiguaAndBarbuda, Country.Argentina, Country.Armenia, Country.Aruba, Country.Australia, Country.Austria, Country.Azerbaijan, Country.Bahamas, Country.Bahrain, Country.Bangladesh, Country.Barbados, Country.Belarus, Country.Belgium, Country.Belize, Country.Benin, Country.Bermuda, Country.Bhutan, Country.BoliviaPlurinationalStateOf, Country.BonaireSintEustatiusAndSaba, Country.BosniaAndHerzegovina, Country.Botswana, Country.BouvetIsland, Country.Brazil, Country.BritishIndianOceanTerritory, Country.BruneiDarussalam, Country.Bulgaria, Country.BurkinaFaso, Country.Burundi, Country.CaboVerde, Country.Cambodia, Country.Cameroon, Country.Canada, Country.CaymanIslands, Country.CentralAfricanRepublic, Country.Chad, Country.Chile, Country.China, Country.ChristmasIsland, Country.CocosKeelingIslands, Country.Colombia, Country.Comoros, Country.CongoDemocraticRepublicOf, Country.Congo, Country.CookIslands, Country.CostaRica, Country.Croatia, Country.Cuba, Country.Curacao, Country.Cyprus, Country.Czechia, Country.CoteDIvoire, Country.Denmark, Country.Djibouti, Country.Dominica, Country.DominicanRepublic, Country.Ecuador, Country.Egypt, Country.ElSalvador, Country.EquatorialGuinea, Country.Eritrea, Country.Estonia, Country.Eswatini, Country.Ethiopia, Country.FalklandIslandsMalvinas, Country.FaroeIslands, Country.Fiji, Country.Finland, Country.France, Country.FrenchGuiana, Country.FrenchPolynesia, Country.FrenchSouthernTerritories, Country.Gabon, Country.Gambia, Country.Georgia, Country.Germany, Country.Ghana, Country.Gibraltar, Country.Greece, Country.Greenland, Country.Grenada, Country.Guadeloupe, Country.Guam, Country.Guatemala, Country.Guernsey, Country.Guinea, Country.GuineaBissau, Country.Guyana, Country.Haiti, Country.HeardIslandAndMcDonaldIslands, Country.HolySee, Country.Honduras, Country.HongKong, Country.Hungary, Country.Iceland, Country.India, Country.Indonesia, Country.IranIslamicRepublicOf, Country.Iraq, Country.Ireland, Country.IsleOfMan, Country.Israel, Country.Italy, Country.Jamaica, Country.Japan, Country.Jersey, Country.Jordan, Country.Kazakhstan, Country.Kenya, Country.Kiribati, Country.KoreaDemocraticPeoplesRepublicOf, Country.KoreaRepublicOf, Country.Kuwait, Country.Kyrgyzstan, Country.LaoPeoplesDemocraticRepublic, Country.Latvia, Country.Lebanon, Country.Lesotho, Country.Liberia, Country.Libya, Country.Liechtenstein, Country.Lithuania, Country.Luxembourg, Country.Macao, Country.Madagascar, Country.Malawi, Country.Malaysia, Country.Maldives, Country.Mali, Country.Malta, Country.MarshallIslands, Country.Martinique, Country.Mauritania, Country.Mauritius, Country.Mayotte, Country.Mexico, Country.MicronesiaFederatedStatesOf, Country.MoldovaRepublicOf, Country.Monaco, Country.Mongolia, Country.Montenegro, Country.Montserrat, Country.Morocco, Country.Mozambique, Country.Myanmar, Country.Namibia, Country.Nauru, Country.Nepal, Country.Netherlands, Country.NewCaledonia, Country.NewZealand, Country.Nicaragua, Country.Niger, Country.Nigeria, Country.Niue, Country.NorfolkIsland, Country.NorthMacedonia, Country.NorthernMarianaIslands, Country.Norway, Country.Oman, Country.Pakistan, Country.Palau, Country.PalestineStateOf, Country.Panama, Country.PapuaNewGuinea, Country.Paraguay, Country.Peru, Country.Philippines, Country.Pitcairn, Country.Poland, Country.Portugal, Country.Qatar, Country.Romania, Country.RussianFederation, Country.Rwanda, Country.Reunion, Country.SaintBarthelemy, Country.SaintHelenaAscensionAndTristandaCunha, Country.SaintKittsAndNevis, Country.SaintLucia, Country.SaintMartin, Country.SaintPierreAndMiquelon, Country.SaintVincentAndGrenadines, Country.Samoa, Country.SanMarino, Country.SaoTomeAndPrincipe, Country.SaudiArabia, Country.Senegal, Country.Serbia, Country.Seychelles, Country.SierraLeone, Country.Singapore, Country.SintMaarten, Country.Slovakia, Country.Slovenia, Country.SolomonIslands, Country.Somalia, Country.SouthAfrica, Country.SouthGeorgiaAndSouthSandwichIslands, Country.SouthSudan, Country.Spain, Country.SriLanka, Country.Sudan, Country.Suriname, Country.SvalbardAndJanMayen, Country.Sweden, Country.Switzerland, Country.SyrianArabRepublic, Country.TaiwanProvinceOfChina, Country.Tajikistan, Country.TanzaniaUnitedRepublicOf, Country.Thailand, Country.TimorLeste, Country.Togo, Country.Tokelau, Country.Tonga, Country.TrinidadAndTobago, Country.Tunisia, Country.Turkey, Country.Turkmenistan, Country.TurksAndCaicosIslands, Country.Tuvalu, Country.Uganda, Country.Ukraine, Country.UnitedArabEmirates, Country.UnitedKingdomOfGreatBritainAndNorthernIreland, Country.UnitedStatesMinorOutlyingIslands, Country.UnitedStatesOfAmerica, Country.Uruguay, Country.Uzbekistan, Country.Vanuatu, Country.VenezuelaBolivarianRepublicOf, Country.VietNam, Country.VirginIslandsBritish, Country.VirginIslandsUS, Country.WallisAndFutuna, Country.WesternSahara, Country.Yemen, Country.Zambia, Country.Zimbabwe];
export var getCountryNameByCode = function getCountryNameByCode(code) {
  var countryName = Object.keys(Country).find(function (key) {
    return Country[key] === code;
  }) || ''; // Insert space before each capital letter and trim the leading space if any

  return countryName.replace(/([A-Z])/g, ' $1').trim();
};